<template>
	<div full-height>
		<div class="display_wrapper" id="non-printable">

			<v-toolbar flat fixed>
			    <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

			    <v-toolbar-title class="white--text" :class="{'two-line-title':offsetTop>=36}">
			    	{{toolbarTitle}}
			    	<div class="toolbar-subtitle" v-if="displayData && offsetTop>=36">
			    		<div class="subtitle-text dark-opacity-color">
			    			{{displayData.mergeTransactionNumber}}
			    		</div>
			    	</div>
			    </v-toolbar-title>

			    <v-spacer></v-spacer>

			    <!-- <v-btn round-borders outline @click="fn_edit" v-if="displayData && displayData.status==1">edit</v-btn> -->

			    <v-btn icon @click="fn_preview" v-if="displayData">
			    	<!-- <v-icon>remove_red_eye</v-icon> -->
			    	<img src="../../../../assets/icon_preview.svg" alt="preview_icon"></img>
			    </v-btn>

			    <v-btn icon @click="fn_edit" v-if="displayData && displayData.status==1">
			    	<v-icon>edit</v-icon>
			    </v-btn>
			</v-toolbar>

			<div full-height overflow-scroll class="display hasToolbar hasBigFooterWithExtention" v-scroll="onScrollTransactionForm">

				<v-alert :value="displayData && displayData.status==0" type="warning" transition="slide-y-transition">
					<span>This transaction has been cancelled!</span>
				</v-alert>

				<v-list nopadding>
				  	<v-list-tile>
			          	<v-list-tile-content>
			              <!-- <v-list-tile-title>{{transactionNumber}}</v-list-tile-title> -->
			              <v-list-tile-title>{{displayData.mergeTransactionNumber}}</v-list-tile-title>
			            </v-list-tile-content>

			            <v-list-tile-action>{{displayData.transactionDate | moment("DD-MMM-YYYY")}}</v-list-tile-action>
				    </v-list-tile>
				</v-list>

			  	<!-- <v-layout grid wrap text-xs-center>
					<v-flex xs3 sm3 md3 pt-2 pb-2 v-ripple @click="fn_bindInvoiceTemplate('sharewhatsapp')">
						<div right-border>
							<div><v-icon>send</v-icon></div>
					    	<div class="font-weight-bold">Send</div>
						</div>	
					</v-flex>

					<v-flex xs3 sm3 md3 pt-2 pb-2 v-ripple @click="fn_bindInvoiceTemplate('print')">
					    <div right-border>
					    	<div><v-icon>print</v-icon></div>
					    	<div class="font-weight-bold">Print</div>
					    </div>
					</v-flex>

					<v-flex xs3 sm3 md3 pt-2 pb-2 v-ripple @click="fn_bindInvoiceTemplate('pdf')">
					    <div right-border>
					    	<div><v-icon>import_export</v-icon></div>
					    	<div class="font-weight-bold">Export</div>
					    </div>
					</v-flex>

					<v-flex xs3 sm3 md3 pt-2 pb-2 v-ripple @click="fn_getBottomMenu">
					    <div>
					    	<div><v-icon>more_horiz</v-icon></div>
					    	<div class="font-weight-bold">More</div>
					    </div>
					</v-flex>
				</v-layout> -->

				<div @click="fn_viewPartyDetails(displayData.partyId)" class="pl-3 pr-3 pt-2 pb-3 white-background">
					<div light-opacity-color font12>Supplier</div>
					<div primary-color font16>{{displayData.partyName}}</div>
				</div>

				<v-list nopadding>
					<!-- <v-list-tile v-if="displayData && displayData.partyName" @click="fn_viewPartyDetails(displayData.partyId)">
			          	<v-list-tile-content>
			              <v-list-tile-title>Supplier</v-list-tile-title>
			            </v-list-tile-content>

			            <v-list-tile-action primary-color>{{displayData.partyName}}</v-list-tile-action>
				    </v-list-tile> -->

				  	<!-- <v-list-tile>
			          	<v-list-tile-content>
			              <v-list-tile-title>Bill No: <span v-if="displayData.refNumber">#{{displayData.refNumber}}</span></v-list-tile-title>
			            </v-list-tile-content>

			            <v-list-tile-action>{{displayData.refDate | moment("DD-MMM-YYYY")}}</v-list-tile-action>
				    </v-list-tile> -->
				    <v-list-tile v-if="displayData.refNumber">
			          	<v-list-tile-content>
			              <v-list-tile-title>Bill No:</v-list-tile-title>
			            </v-list-tile-content>

			            <v-list-tile-action>{{displayData.refNumber}}</v-list-tile-action>
				    </v-list-tile>

				    <v-list-tile v-if="displayData.refDate">
			          	<v-list-tile-content>
			              <v-list-tile-title>Bill Date:</v-list-tile-title>
			            </v-list-tile-content>

			            <v-list-tile-action>{{displayData.refDate | moment("DD-MMM-YYYY")}}</v-list-tile-action>
				    </v-list-tile>

				    <v-list-tile v-if="displayData && (displayData.placeOfSupplyId != $root.CurrentBusiness.StateID) && $root.CurrentBusiness.GSTRegistrationStatus==1 && displayData.placeOfSupplyName">
			          	<v-list-tile-content>
			              <v-list-tile-title>Place of Supply</v-list-tile-title>
			            </v-list-tile-content>

			            <v-list-tile-action>{{displayData.placeOfSupplyName}}</v-list-tile-action>
				    </v-list-tile>

				    <v-list-tile v-if="displayData.placeOfSupplyCountryName">
			          	<v-list-tile-content>
			              <v-list-tile-title>Country</v-list-tile-title>
			            </v-list-tile-content>

			            <v-list-tile-action>{{displayData.placeOfSupplyCountryName}}</v-list-tile-action>
				    </v-list-tile>
				</v-list>

				<v-list nopadding margin-top-ten v-if="displayData.transactionLedgers">
					<v-subheader>Expense Category</v-subheader>
					<v-divider></v-divider>
					<v-list-tile>
			          	<!-- <v-list-tile-content>
			              <v-list-tile-title>{{displayData.transactionLedgers[0].accountLedgerName}}</v-list-tile-title>
			            </v-list-tile-content> -->
			            <v-list-tile-content>
			              <v-list-tile-title>{{displayData.expenseCategoryName}}</v-list-tile-title>
			            </v-list-tile-content>

			            <v-list-tile-action v-if="!displayData.transactionProducts">
			            	<!-- &#8377; {{displayData.transactionLedgers[0].amount ? $root.numberToLocale(displayData.transactionLedgers[0].amount) : displayData.transactionLedgers[0].amount}} -->
							 &#8377; {{$root.numberToLocale(displayData.netAmount)}}
			            </v-list-tile-action>
				    </v-list-tile>
				</v-list>

					<v-list nopadding auto-height-tile margin-top-ten v-if="fn_checkForItems()">

						<v-divider></v-divider>

						<!-- <v-subheader class="subheader-dense">Items</v-subheader> -->
						<v-list-tile>
						 	<v-list-tile-content>
						    	<v-list-tile-title>Items</v-list-tile-title>
						  	</v-list-tile-content>
						</v-list-tile>

						<v-divider></v-divider>
						
						<div v-for="(item, itemIndex) in displayData.transactionProducts" :key="itemIndex">
							<v-list-tile class="right-subtitle-tile custom-action-tile">
							    <v-list-tile-content>
							      <v-list-tile-title class="mb-1">{{item.productName}}</v-list-tile-title>
							      <!-- <v-list-tile-sub-title class="mb-1"><span class="right_subtitle">&#8377; {{item.netAmount ? $root.numberToLocale(item.netAmount) : item.netAmount}}</span> </v-list-tile-sub-title> -->

							      <v-list-tile-sub-title class="mb-1" v-for="(variant, vIndex) in item.productVariants" :key="vIndex" v-if="variant.qty">
							      	{{variant.qty}} {{variant.unitName}} X {{item.rate}}
							      </v-list-tile-sub-title>

							      <v-list-tile-sub-title class="mb-1" v-for="(addOns, addOnsIndex) in item.transactionProductAddOns" :key="vIndex" v-if="addOns.value && !addOns.isGst">
							      	{{addOns.name}}
							      	<span v-if="addOns.percentage"> @{{addOns.percentage}}%</span>: {{addOns.nature ? '-' : ''}} {{addOns.value ? $root.numberToLocale(addOns.value) : addOns.value}}
							      </v-list-tile-sub-title>

							      <v-list-tile-sub-title class="mb-1" v-if="displayData.taxMode">
							      	GST @{{item.taxpercent}}%: {{item.taxvalue ? $root.numberToLocale(item.taxvalue) : item.taxvalue}} {{displayData.isRcmApplicable ? ' (RCM)' : ''}}
							      </v-list-tile-sub-title>

							      <v-list-tile-sub-title class="mb-1" v-if="displayData.taxMode && item.cessvalue">
							      	Cess<span v-if="item.cesspercent!=null"> @{{item.cesspercent}}%</span>: {{item.cessvalue ? $root.numberToLocale(item.cessvalue) : item.cessvalue}} {{displayData.isRcmApplicable ? ' (RCM)' : ''}}
							      </v-list-tile-sub-title>

							      <v-list-tile-sub-title class="mb-1" v-if="item.description">
							      	{{item.description}}
							      </v-list-tile-sub-title>

							    </v-list-tile-content>

							    <v-list-tile-action>
							    	{{$root.numberToLocale(item.netAmount)}}
							    	<!-- <div v-if="displayData.isRcmApplicable">
							    		&#8377; {{fn_itemTotal(item)}}
							    	</div>
							    	<div v-else>&#8377; {{$root.numberToLocale(item.netAmount)}}</div> -->
								    <!-- <div>&#8377; {{item.netAmount ? $root.numberToLocale(item.netAmount) : item.netAmount}}</div> -->
							    </v-list-tile-action>

							</v-list-tile>

							<v-divider v-if="displayData.transactionProducts.length-1 != itemIndex"></v-divider>
						</div>

					</v-list>


					<v-divider v-if="fn_checkForItems()"></v-divider>

					<v-list nopadding v-if="displayData.transactionProducts && displayData.transactionProducts.length" class="oneline-tile-dense">

						<!-- <v-list-tile>
						 	<v-list-tile-content>
						    	<v-list-tile-title>Total Qty</v-list-tile-title>
						  	</v-list-tile-content>
						  	<v-list-tile-action>{{totalQty}} Units</v-list-tile-action>
						</v-list-tile> -->

						<!-- <v-divider></v-divider> -->
						<v-list-tile v-if="displayData.transactionProducts && displayData.transactionProducts.length && fn_getTotalQty(1)">
							<v-list-tile-content>
								<v-list-tile-title>Total Qty</v-list-tile-title>
							</v-list-tile-content>
							<v-list-tile-action>{{fn_getTotalQty(1)}}</v-list-tile-action>
						</v-list-tile>

					  	<v-list-tile>
				          	<v-list-tile-content>
				              <!-- <v-list-tile-title>Gross Amount</v-list-tile-title> -->
				              <v-list-tile-title>Items Total</v-list-tile-title>
				            </v-list-tile-content>
				            <v-list-tile-action>{{displayData.grossAmount ? $root.numberToLocale(displayData.grossAmount) : displayData.grossAmount}}</v-list-tile-action>
					    </v-list-tile>

					    <v-list-tile v-for="(addOns, index) in addOnsSummary" :key="index">
				          	<v-list-tile-content>
				              <!-- <v-list-tile-title>{{addOns.addOnsName}}</v-list-tile-title> -->
				              <v-list-tile-title>{{addOns.addOnsNature ? 'Items Discount' : addOns.addOnsName}}</v-list-tile-title>
				            </v-list-tile-content>
				            <v-list-tile-action>{{addOns.addOnsNature ? '-' : ''}}{{addOns.value ? $root.numberToLocale(addOns.value) : addOns.value}}</v-list-tile-action>
					    </v-list-tile>

					    <v-list-tile v-for="(addOns, index) in gstAddOns" :key="index">
				          	<v-list-tile-content>
				              <v-list-tile-title>{{addOns.addOnsName}}{{displayData.isRcmApplicable ? ' (RCM)' : ''}}</v-list-tile-title>
				            </v-list-tile-content>
				            <v-list-tile-action>{{addOns.addOnsNature ? '-' : ''}}{{addOns.value ? $root.numberToLocale(addOns.value) : addOns.value}}</v-list-tile-action>
					    </v-list-tile>

					    <!-- <v-divider></v-divider> -->

					    <!-- <v-list-tile>
				          	<v-list-tile-content>
				              <v-list-tile-title>Net Amount</v-list-tile-title>
				            </v-list-tile-content>
				            <v-list-tile-action>&#8377; {{displayData.netAmount ? $root.numberToLocale(displayData.netAmount) : displayData.netAmount}}</v-list-tile-action>
					    </v-list-tile> -->
					</v-list>

					<!-- <v-list nopadding margin-top-ten v-if="displayData.transactionAddOns && displayData.transactionAddOns.length">
						<v-subheader>Discounts/Taxes/Other Charges</v-subheader>
						<v-divider></v-divider>
						<v-list-tile v-for="(addOns, index) in displayData.transactionAddOns" :key="index">
				          	<v-list-tile-content>
				              <v-list-tile-title>{{addOns.addOnsName}}</v-list-tile-title>
				            </v-list-tile-content>
				            <v-list-tile-action>{{addOns.addOnsNature ? '(-)' : ''}}{{addOns.value ? $root.numberToLocale(addOns.value) : addOns.value}}</v-list-tile-action>
					    </v-list-tile>
					</v-list> -->

					<!-- <div nopadding white-background margin-top-ten v-if="isOtherChargesAddons">
						<v-list full-width nopadding>
						  	<v-list-tile>
					          	<v-list-tile-content>
					              <v-list-tile-title medium-theme-color>Other Charges</v-list-tile-title>
					            </v-list-tile-content>
						    </v-list-tile>
						</v-list>

						<v-divider></v-divider>

						<v-list-tile v-for="(addOns, index) in displayData.transactionAddOns" :key="index" v-if="addOns.addOnsType==3">
				          	<v-list-tile-content>
				              <v-list-tile-title>{{addOns.addOnsName}}</v-list-tile-title>
				            </v-list-tile-content>
				            <v-list-tile-action>{{addOns.addOnsNature ? '(-)' : ''}}{{addOns.value ? $root.numberToLocale(addOns.value) : addOns.value}}</v-list-tile-action>
					    </v-list-tile>
					</div>

					<div nopadding white-background margin-top-ten v-if="isDiscountAddons">
						<v-list full-width nopadding>
						  	<v-list-tile>
					          	<v-list-tile-content>
					              <v-list-tile-title medium-theme-color>Discounts</v-list-tile-title>
					            </v-list-tile-content>
						    </v-list-tile>
						</v-list>

						<v-divider></v-divider>

						<v-list-tile v-for="(addOns, index) in displayData.transactionAddOns" :key="index" v-if="addOns.addOnsType==1">
				          	<v-list-tile-content>
				              <v-list-tile-title>{{addOns.addOnsName}}</v-list-tile-title>
				            </v-list-tile-content>
				            <v-list-tile-action>{{addOns.addOnsNature ? '(-)' : ''}}{{addOns.value ? $root.numberToLocale(addOns.value) : addOns.value}}</v-list-tile-action>
					    </v-list-tile>
					</div>

					<div nopadding white-background margin-top-ten v-if="isTaxAddons">
						<v-list full-width nopadding>
						  	<v-list-tile>
					          	<v-list-tile-content>
					              <v-list-tile-title medium-theme-color>Taxes</v-list-tile-title>
					            </v-list-tile-content>
						    </v-list-tile>
						</v-list>

						<v-divider></v-divider>

						<v-list-tile v-for="(addOns, index) in displayData.transactionAddOns" :key="index" v-if="addOns.addOnsType==2">
				          	<v-list-tile-content>
				              <v-list-tile-title>{{addOns.addOnsName}}</v-list-tile-title>
				            </v-list-tile-content>
				            <v-list-tile-action>{{addOns.addOnsNature ? '(-)' : ''}}{{addOns.value ? $root.numberToLocale(addOns.value) : addOns.value}}</v-list-tile-action>
					    </v-list-tile>
					</div> -->

					<div class="oneline-tile-dense" margin-top-ten full-width v-if="displayData.transactionAddOns && displayData.transactionAddOns.length">
						<div white-background v-if="isOtherChargesAddons">
							<v-list-tile v-for="(addOns, index) in displayData.transactionAddOns" :key="index" v-if="addOns.addOnsType==3">
					          	<v-list-tile-content>
					              <v-list-tile-title>{{addOns.addOnsName}}</v-list-tile-title>
					            </v-list-tile-content>
					            <v-list-tile-action>{{addOns.addOnsNature ? '(-) ' : ''}}{{addOns.value ? $root.numberToLocale(addOns.value) : addOns.value}}</v-list-tile-action>
						    </v-list-tile>
						</div>

						<div white-background v-if="isDiscountAddons">
							<v-list-tile v-for="(addOns, index) in displayData.transactionAddOns" :key="index" v-if="addOns.addOnsType==1">
					          	<v-list-tile-content>
					              <v-list-tile-title>{{addOns.addOnsName}}</v-list-tile-title>
					            </v-list-tile-content>
					            <v-list-tile-action>{{addOns.addOnsNature ? '(-) ' : ''}}{{addOns.value ? $root.numberToLocale(addOns.value) : addOns.value}}</v-list-tile-action>
						    </v-list-tile>
						</div>

						<div white-background v-if="isTaxAddons">
							<v-list-tile v-for="(addOns, index) in displayData.transactionAddOns" :key="index" v-if="addOns.addOnsType==2">
					          	<v-list-tile-content>
					              <v-list-tile-title>{{addOns.addOnsName}}{{displayData.isRcmApplicable ? ' (RCM)' : ''}}</v-list-tile-title>
					            </v-list-tile-content>
					            <v-list-tile-action>{{addOns.addOnsNature ? '(-) ' : ''}}{{addOns.value ? $root.numberToLocale(addOns.value) : addOns.value}}</v-list-tile-action>
						    </v-list-tile>
						</div>
					</div>	

					<v-list class="oneline-tile-dense" nopadding>

					    <div v-if="displayData.transactionTds && displayData.transactionTds.length">
					    	<v-list-tile v-for="(tds, index) in displayData.transactionTds" :key="index">
					          	<v-list-tile-content>
					              <v-list-tile-title>{{tds.tdsAccountName}}</v-list-tile-title>
					            </v-list-tile-content>
					            <v-list-tile-action>-{{tds.amount ? $root.numberToLocale(tds.amount) : tds.amount}}</v-list-tile-action>
						    </v-list-tile>

						    <!-- <v-divider></v-divider> -->
					    </div>

					    <!-- <v-list-tile v-if="displayData && displayData.roundOffValue">
				          	<v-list-tile-content>
				              <v-list-tile-title>Round Off</v-list-tile-title>
				            </v-list-tile-content>
				            <v-list-tile-action>&#8377; {{displayData.roundOffValue}}</v-list-tile-action>
					    </v-list-tile> -->
					    <v-list-tile v-if="roundOffValue">
				          	<v-list-tile-content>
				              <v-list-tile-title>Round Off</v-list-tile-title>
				            </v-list-tile-content>
				            <v-list-tile-action>&#8377; {{roundOffValue}}</v-list-tile-action>
					    </v-list-tile>

					    <!-- <v-divider v-if="roundOffValue"></v-divider> -->
					    <v-divider></v-divider>
					    
					    <v-list-tile font-medium>
				          	<v-list-tile-content>
				              <v-list-tile-title>Total Amount</v-list-tile-title>
				            </v-list-tile-content>
				            <v-list-tile-action>&#8377; {{displayData.roundedAmount ? $root.numberToLocale(displayData.roundedAmount) : displayData.roundedAmount}}</v-list-tile-action>
					    </v-list-tile>
					</v-list>

					<v-list nopadding margin-top-ten v-if="displayData.paymentTerm && $root.appVersion >= 117">
						<v-list-tile>
				          	<v-list-tile-content>
				              <v-list-tile-title>Term of Payment</v-list-tile-title>
				            </v-list-tile-content>
				            <v-list-tile-action>{{displayData.paymentTerm != -1 ? displayData.paymentTerm + ' Days' : 'No Due Date'}}</v-list-tile-action>
					    </v-list-tile>

						<v-list-tile v-if="displayData.paymentTerm != -1">
				          	<v-list-tile-content>
				              <v-list-tile-title>Due Date</v-list-tile-title>
				            </v-list-tile-content>
				            <v-list-tile-action>{{fn_dueDate(displayData.refDate, displayData.transactionDate, displayData.paymentTerm) | moment("DD-MMM-YYYY")}}</v-list-tile-action>
					    </v-list-tile>
					</v-list>

					<div v-if="displayData.description" margin-top-ten>
						<v-list full-width nopadding>
						  	<v-list-tile>
					          	<v-list-tile-content>
					              <v-list-tile-title>Description</v-list-tile-title>
					            </v-list-tile-content>
						    </v-list-tile>
						</v-list>

						<v-divider></v-divider>

						<v-card flat class="note-card">
						  <v-card-text font16 v-html="displayData.description" white-space-pre-line></v-card-text>
						</v-card>
					</div>

					<div v-if="displayData.notes" margin-top-ten>
						<v-list full-width nopadding>
						  	<v-list-tile>
					          	<v-list-tile-content>
					            	<v-list-tile-title medium-theme-color>Notes</v-list-tile-title>
					            </v-list-tile-content>
						    </v-list-tile>
						</v-list>

						<v-divider></v-divider>

						<v-card flat class="note-card">
						  <v-card-text font16 v-html="displayData.notes" white-space-pre-line></v-card-text>
						</v-card>
					</div>

				
				<v-layout row wrap margin-top-ten white-background v-if="customFields.length">

					<v-expansion-panel nomargin>

					    <v-expansion-panel-content v-for="(item, index) in customFields" :key="index">

					      <!-- <v-divider></v-divider> -->

					      <div slot="header" font16>{{item.sectionName}}</div>

					      <v-divider class="pb-3"></v-divider>

					      <v-card v-for="(fieldItem, itemIndex) in item.items" :key="itemIndex" v-if="fieldItem.fieldValue">
					        <v-card-text class="pt-0">
					        	<div font12 light-theme-color>{{fieldItem.fieldName}}</div>
					        	<div font16 v-if="fieldItem.fieldDataType=='yes/no'">{{fieldItem.fieldValue ? 'Yes' : 'No'}}</div>

					        	<div font16 v-else-if="fieldItem.fieldDataType=='dateTime'">
					        		<span v-if="fieldItem.fieldValue">{{fieldItem.fieldValue | moment("DD-MMM-YYYY")}}</span>
					        		<span v-else>-</span>
					        	</div>
					        	
					  			<div font16 v-html="fieldItem.fieldValue ? fieldItem.fieldValue : '-'" white-space-pre-line v-else></div>
					        </v-card-text>
					      </v-card>

					    </v-expansion-panel-content>

					  </v-expansion-panel>

				</v-layout>

				<div v-if="displayData.documentDetails" margin-top-ten>
					<v-list full-width nopadding>
					  	<v-list-tile>
				          	<v-list-tile-content>
								<v-list-tile-title>Attachments {{ displayData.documentDetails.length ? '('+displayData.documentDetails.length+')' : '' }}</v-list-tile-title>
				            </v-list-tile-content>
					    </v-list-tile>
					</v-list>

					<v-divider></v-divider>

					<template v-for="(item, index) in displayData.documentDetails">
						<v-list-tile white-background :key="index">
				          	<v-list-tile-content>
				              <v-list-tile-title>{{item.fileName}}</v-list-tile-title>
				            </v-list-tile-content>

				            <v-list-tile-action>
	            				<v-btn flat icon :disabled="$root.CurrentBusiness.temporaryBusiness ? true : false" @click.native="fn_checkFileExist(item)"><v-icon>cloud_download</v-icon></v-btn>
				            </v-list-tile-action>
					    </v-list-tile>
					    <v-divider v-if="displayData.documentDetails.length-1 != index"></v-divider>
					</template>
				</div>

				<v-list margin-top-ten nopadding full-width v-if="displayData && displayData.paymentMode==1">
					<!-- <v-subheader full-width border-bottom-thin nomargin norightpadding>Payment Mode</v-subheader> -->
					<v-list-tile>
			          	<v-list-tile-content>
			              <v-list-tile-title>Payment Mode</v-list-tile-title>
			            </v-list-tile-content>
				    </v-list-tile>
					<v-divider></v-divider>
					<div v-for="(item, index) in displayData.transactionLedgers" :key="index" v-if="item.orderNumber != 1">
						<v-list-tile>
					  		<v-list-tile-content>
					  		 	<v-list-tile-title>
					  		 		{{item.accountLedgerId == creditAccountLedgerId ? 'On Credit' : item.accountLedgerName}}
					  		 	</v-list-tile-title>
					  		</v-list-tile-content>
					  		<v-list-tile-action>&#8377; {{item.amount ? $root.numberToLocale(item.amount) : item.amount}}</v-list-tile-action>
					  	</v-list-tile>	
					</div>
				</v-list>

				<v-footer class="invoice-footer-actions">

					<v-layout white-background grid wrap text-xs-center>
						<v-flex xs3 sm3 md3 pt-2 pb-2 v-ripple @click="fn_bindInvoiceTemplate('sharewhatsapp')">
							<div right-border>
								<!-- <div><v-icon>send</v-icon></div> -->
								<div style="height:26px"><img src="../../../../assets/icon_whatsapp.svg" alt="whatapp_icon"></img></div>
						    	<div font11 class="font-weight-bold">Send</div>
							</div>	
						</v-flex>

						<v-flex xs3 sm3 md3 pt-2 pb-2 v-ripple @click="fn_bindInvoiceTemplate('share')">
						    <div right-border>
						    	<div><v-icon>share</v-icon></div>
						    	<div font11 class="font-weight-bold">Share</div>
						    </div>
						</v-flex>

						<v-flex xs3 sm3 md3 pt-2 pb-2 v-ripple @click="fn_bindInvoiceTemplate('print')">
						    <div right-border>
						    	<div><v-icon>print</v-icon></div>
						    	<div font11 class="font-weight-bold">Print</div>
						    </div>
						</v-flex>

						<v-flex xs3 sm3 md3 pt-2 pb-2 v-ripple @click="fn_bindInvoiceTemplate('pdf')">
						    <div right-border>
						    	<div><v-icon>vertical_align_bottom</v-icon></div>
						    	<div font11 class="font-weight-bold">Download</div>
						    </div>
						</v-flex>

						<!-- <v-flex xs3 sm3 md3 pt-2 pb-2 v-ripple @click="fn_preview">
						    <div right-border>
						    	<div><v-icon>remove_red_eye</v-icon></div>
								<div class="font-weight-bold">Preview</div>
						    </div>
						</v-flex> -->
					</v-layout>	

					<div v-ripple class="pb-2 pt-2" style="width:20%" center-align white-background @click="fn_getBottomMenu">
						<div><v-icon>more_horiz</v-icon></div>
						<div font11 class="font-weight-bold">More</div>
		            </div>	

				</v-footer>

							

			</div>

			<dialog-confirmation ref="ref_dialogCancelDeleteTransaction" :header="confirmationDialogHeader" :confirmationMessage="confirmationMessage" :actionMethod="fn_callCancelTransaction" :params="{type:actionType}" :displayView='true' okBtnText="Yes" cancelBtnText="No" icon="warning" iconClass="redcolor" textClass="redcolor"></dialog-confirmation>
			
			<v-snackbar v-model="snackbar" :timeout="2000">{{snackbar_msg}}</v-snackbar>

			<!-- binding in the background to calculate full page height for header, body and footer -->
			<div id="hidden_invoice_preview" v-if="$root.TransactionSettings.fullPagePrint">
				<component :is="previewTemplate" ref="ref_previewTemplate" :data="printData" v-if="previewTemplate && printData!=null"></component>
			</div>
		</div>

		<div id="printable" full-width>
			<!-- <print-template-inventory ref="ref_printTemplate" :data="printData" v-if="printData!=null && inventory">
			</print-template-inventory>

			<print-template-non-inventory ref="ref_printTemplate" :data="printData" v-if="printData!=null && !inventory">
			</print-template-non-inventory> -->
			<component :is="printTemplate" ref="ref_printTemplate" :data="printData" v-if="printTemplate && printData!=null"></component>
		</div>

		<!-- <dialog-permission ref="ref_dialogPermission"></dialog-permission> -->
		<dialog-loading ref="ref_dialogLoading" message="Downloading..."></dialog-loading>

		<v-snackbar v-model="snackbarOpenFile">
          File downloaded!
          <v-btn flat color="primary" @click.native="$root.fn_openDownloadedFile">Open</v-btn>
        </v-snackbar>
	</div>
</template>

<script>
const menuItem = require('../../../../config.js').configs.menuItem;
const transactionForms = require('../../../../config.js').configs.transactionForms;
const transactionTypes = require('../../../../config.js').configs.transactionTypes;

// import printTemplateInventory from '../../../invoice_templates/tax_invoice'
// import printTemplateNonInventrory from '../../../invoice_templates/invoices/template101'

import dialogConfirmation from '../../../dialogs/dialog_confirmation'
import dialogLoading from '../../../dialogs/dialog_loading'

import {transactionMixin} from '../../transaction_mixin'

	export default{
		props:['settings'],
		mixins: [transactionMixin],
		data(){
			return{
				displayData:{},
				toolbarTitle:null,
				snackbar:false,
				snackbar_msg:null,
				addOnsSummary:[],
				customFields:[],
				itemsQuanity:[],
				// inventory:true,
				actionType:null,
				confirmationDialogHeader:null,
				confirmationMessage:null,
				gstAddOns:[],
				printData:null,
				printTemplate:null,
				previewTemplate:null,
				isTaxAddons:false,
				isDiscountAddons:false,
				isOtherChargesAddons:false
			}
		},
		components:{
			'dialog-confirmation': dialogConfirmation,
			'dialog-loading':dialogLoading
			// 'print-template-inventory':printTemplateInventory,
			// 'print-template-non-inventory':printTemplateNonInventrory
		},
		methods:{

			fn_itemTotal: function(item){
				let netAmount = item.netAmount ? item.netAmount : 0;
				let taxValue = item.taxvalue ? item.taxvalue : 0;
				let cessValue = item.cessvalue ? item.cessvalue : 0;
				return this.$root.numberToLocale(netAmount - taxValue - cessValue);
			},

			fn_preview: function(){
				this.fn_previewInvoice(true, 'purchase');
				// if(this.inventory){
				// 	this.fn_previewInvoice(true, 'purchase');
				// }
				// else{
				// 	this.fn_previewInvoice(true, 'purchase', 'ab');
				// }
			},

			fn_goBack: function(){
				this.$router.go(-1);
			},

			fn_shareInvoice: function(type, fnName){
				// this.displayData.transactionTypeFormName = "Expense";

				let shareObj = {};
				shareObj.shareType = type=='sharewhatsapp' ? 'share' : 'ShareOther';
				// shareObj.shareVia = this.displayData.primaryMobileNumber && type == 'sharewhatsapp' ? 'ShareOnWhatsApp' : 'Share';
				shareObj.type = 'pdf';
				shareObj.primaryMobileNumber = this.displayData.primaryMobileNumber && type == 'sharewhatsapp' ? this.displayData.primaryMobileNumber : null;
				// shareObj.subject = this.toolbarTitle + " Details";
				shareObj.subject = this.toolbarTitle + " #" + this.displayData.mergeTransactionNumber + " from " + this.$root.CurrentBusiness.BusinessName;
				shareObj.email = this.displayData.email ? [this.displayData.email] : null ;

				let party = this.displayData.partyName ? this.displayData.partyName + ',' : '';

        		// shareObj.textMessage = "Dear "+party+"\n\nBelow are your " + this.toolbarTitle + " details. Please find the attached pdf.\n\nTransaction Date: "+this.$moment(this.displayData.transactionDate).format('DD-MMM-YYYY')+"\nTotal Amount: ₹ "+this.$root.fixed2Decimal(this.displayData.roundedAmount)+"\n\nThank You,\n"+this.$root.CurrentBusiness.BusinessName;
				shareObj.textMessage = this.$tShare('share.invoiceMessage', {
					party: party,
					title: this.toolbarTitle,
					number: this.displayData.mergeTransactionNumber,
					date: this.$moment(this.displayData.transactionDate).format('DD-MMM-YYYY'),
					amount: this.$root.numberToLocale(this.displayData.roundedAmount),
					businessName: this.$root.CurrentBusiness.BusinessName
				});

				// shareObj.textMessage = "Dear "+this.displayData.partyName+",\n\nBelow are your invoice details. Please find the attached pdf of your invoice.\n\nInvoice Date: "+this.$moment(this.displayData.createdDate).format('DD-MMM-YYYY')+"\nTotal Amount: ₹ "+this.$root.fixed2Decimal(this.displayData.roundedAmount)+"\n\nThank You,\n"+this.$root.CurrentBusiness.BusinessName;
				this.fn_getPrintData(fnName, this.displayData.transactionId, 'pdf', shareObj);
			},

			// fn_getPrint: function(type){
			// 	let name = this.inventory ? 'InvoiceData' : 'ExpensePrintData';
			// 	this.fn_getPrintData(name, this.displayData.transactionId, type);
			// },

			fn_callCancelTransaction: function(paramObj){
				// this.$refs['ref_dialogCancelDeleteTransaction'].dialog_confimation = false;
				// this.fn_cancelTransaction(this.displayData.transactionId, 'display');
				this.$refs['ref_dialogCancelDeleteTransaction'].dialog_confimation = false;

				let self = this;
				if(paramObj.type=='cancel'){
					this.fn_cancelTransaction(this.displayData.transactionId, this.displayData.transactionListId);	
				}
				else{
					let transactionNumber = this.displayData.mergeTransactionNumber;
					this.fn_deleteTransaction(this.displayData.transactionId, this.displayData.transactionListId, function(status){
						if(status){
							// self.snackbar = true;
							// self.snackbar = '#'+transactionNumber+ ' deleted parmanently!.';
							self.showToast('#'+transactionNumber+ ' deleted parmanently');
							self.$router.go(-1);
						}
						else{
							self.showToast('Something went wrong. Try again!');
							// self.snackbar = true;
							// self.snackbar = 'Something went wrong. Try again!.';	
						}
					});
				}
			},

			fn_initializeSettings: function () {
				transactionForms.filter(item => {
					if(item.id == this.settings.transactionTypeId){
						this.toolbarTitle = item.title;
					}
				})
			},

			fn_comingSoon: function () {
				// this.snackbar_msg = "Coming Soon..";
				// this.snackbar = true;
				this.showToast("under developement");
			},

			fn_get: function(itemId){
				var self = this;
		  		this.getData('Expense', itemId, 
					{
						onSuccess: function(response){
				          	console.log(response);
				          	self.displayData = JSON.parse(response);

				          	if(self.displayData.transactionProducts && self.displayData.transactionProducts.length){
				          		// sorting items as per order number
								self.displayData.transactionProducts.sort(function(a, b){
								  	return a.orderNumber - b.orderNumber;
								});

				          		// self.inventory = true;
				          		self.fn_calculateAddOnsSummary();
				          		self.fn_itemsSummary();
				          	}
				          	// else{
				          	// 	self.inventory = false;
				          	// }

						  	self.fn_bindCustomFields();
						  	if(self.displayData.transactionAddOns && self.displayData.transactionAddOns.length){
			          			self.fn_checkTransactionAddOns();	
			          		}
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_calculateAddOnsSummary: function () {


				let transactionProducts = JSON.parse(JSON.stringify(this.displayData.transactionProducts));

				let self = this;

				transactionProducts.forEach(function (item) {
					
					if(item.transactionProductAddOns){

						item.transactionProductAddOns.forEach(function (addOnsItem) {

							self.fn_checkItemExist(addOnsItem, function (itemIndex) {

								if(itemIndex==-1){
									if(addOnsItem.isGst){
										self.gstAddOns.push(addOnsItem);
									}
									else{
										self.addOnsSummary.push(addOnsItem);
									}
								}
								else{
									if(addOnsItem.isGst){
										let addOnsTotalValue = self.gstAddOns[itemIndex].value + addOnsItem.value;
										self.gstAddOns[itemIndex].value = self.roundUpto2Decimals(addOnsTotalValue);
										self.$forceUpdate();
									}
									else{
										let addOnsTotalValue = self.addOnsSummary[itemIndex].value + addOnsItem.value;
										self.addOnsSummary[itemIndex].value = self.roundUpto2Decimals(addOnsTotalValue);
										self.$forceUpdate();
									}
								}

							})

							console.log(self.addOnsSummary);

						})

					}
					
				})			

			},

			// fn_calculateAddOnsSummary: function () {


			// 	let transactionProducts = JSON.parse(JSON.stringify(this.displayData.transactionProducts));

			// 	let self = this;

			// 	transactionProducts.forEach(function (item) {
					
			// 		if(item.transactionProductAddOns){

			// 			item.transactionProductAddOns.forEach(function (addOnsItem) {

			// 				self.fn_checkItemExist(addOnsItem.addOnsId, function (itemIndex) {

			// 					if(itemIndex==-1){
			// 						self.addOnsSummary.push(addOnsItem);
			// 					}
			// 					else{
			// 						let addOnsTotalValue = self.addOnsSummary[itemIndex].value + addOnsItem.value;
			// 						self.addOnsSummary[itemIndex].value = self.roundUpto2Decimals(addOnsTotalValue);
			// 						self.$forceUpdate();
			// 					}

			// 				})

			// 				console.log(self.addOnsSummary);

			// 			})

			// 		}
					
			// 	})			

			// },

			fn_checkItemExist: function (addOnsItem, callback) {
				let itemIndex = null;

				if(addOnsItem.isGst){
					itemIndex = this.gstAddOns.findIndex(item=>{
						return item.addOnsId == addOnsItem.addOnsId;
					});
				}
				else{
					itemIndex = this.addOnsSummary.findIndex(item=>{
						return item.addOnsId == addOnsItem.addOnsId;
					});
				}

				callback(itemIndex);
			},

			// fn_checkItemExist: function (addOnsId, callback) {
			// 	let itemIndex = this.addOnsSummary.findIndex(item=>{
			// 		return item.addOnsId == addOnsId;
			// 	});

			// 	callback(itemIndex);
			// },

			fn_bindCustomFields: function () {
				let sec = JSON.parse(JSON.stringify(this.displayData.transactionSections));
				let sections = sec.sort(function(a, b){return a.orderNumber - b.orderNumber});
				// let sections = JSON.parse(JSON.stringify(this.displayData.transactionSections));
				let fields = JSON.parse(JSON.stringify(this.displayData.transactionFields));

				let self = this;
				sections.forEach(function (sectionItem) {
					sectionItem.items = [];
					fields.forEach(function (item) {

						if(item.sectionId == sectionItem.sectionId){
							sectionItem.items.push(item);
						}
					})
					self.customFields.push(sectionItem);
				})

			},

			fn_itemsSummary: function () {
				let self = this;
				this.displayData.transactionProducts.forEach(function (item) {

					let taxpercent = 0;
					let taxvalue = 0;
					item.transactionProductAddOns.forEach(function (addOnsItem) {
						if(addOnsItem.isGst == 1){
							taxpercent += addOnsItem.percentage;
							taxvalue += addOnsItem.value;
						}
						else if(addOnsItem.isGst == 2){
							item.cesspercent = addOnsItem.percentage;
							item.cessvalue = addOnsItem.value;
						}
					});

					item.taxpercent = taxpercent;
					item.taxvalue = taxvalue;

					item.productVariants.forEach(function (variantItem) {

	    				let qty = variantItem.qty;

	    				let itemIndex = self.itemsQuanity.findIndex(existingItem=>{
	    					return existingItem.unitId == variantItem.unitId && existingItem.packQuantity == variantItem.packQuantity;
	    				});

	    				if(itemIndex!=-1){
	    					self.itemsQuanity[itemIndex].qty += qty;
	    				}
	    				else{
	    					let vObj = {};
		    				vObj.unitId = variantItem.unitId;
		    				vObj.unitName = variantItem.unitName;
		    				vObj.packQuantity = variantItem.packQuantity;
		    				vObj.qty = variantItem.qty;
		    				self.itemsQuanity.push(vObj);
	    				}
		    		})
				})
			},

			fn_bindInvoiceTemplate: function(type){

				if(this.disableAction){
					return;
				}

				// let fnName = this.inventory ? 'InvoiceData' : 'AccountBookPrintData';
				let fnName = 'InvoiceData';

				this.disableAction = true;

				let self = this;
				setTimeout(function(){
					self.disableAction = false;
				},500);

				this.printTemplate = null;
				this.printData = null;

				// this.printTemplate = require('../../../invoice_templates/invoices/template'+this.displayData.invoiceTemplate).default;
				this.previewTemplate = require('../../../invoice_templates/invoices/template'+this.displayData.invoiceTemplate).default;
				if(this.$root.TransactionSettings.fullPagePrint){
					this.printTemplate = require('../../../invoice_templates/invoices/template1001').default;
				}
				else{
					this.printTemplate = require('../../../invoice_templates/invoices/template'+this.displayData.invoiceTemplate).default;
				}
				console.log(this.printTemplate);

				if(type=='sharewhatsapp'){
					this.fn_shareInvoice('sharewhatsapp', fnName);
				}
				else if(type=='print'){
					this.fn_getPrintData(fnName, this.displayData.transactionId, 'print');
				}
				else if(type=='pdf'){
					this.fn_getPrintData(fnName, this.displayData.transactionId, 'pdf');
				}
				else if(type=='share'){
					this.fn_shareInvoice('share', fnName);
				}

				setTimeout(() => {
					this.previewTemplate = null;
				}, 5000);
			},

			fn_checkTransactionAddOns: function(){
				for(let i=0; i<this.displayData.transactionAddOns.length; i++){
					if(this.displayData.transactionAddOns[i].addOnsType == 1){
						this.isDiscountAddons = true;
					}
					else if(this.displayData.transactionAddOns[i].addOnsType == 2){
						this.isTaxAddons = true;
					}
					else if(this.displayData.transactionAddOns[i].addOnsType == 3){
						this.isOtherChargesAddons = true;
					}
				}
			},

			fn_getBottomMenu: function (tagId) {

				var bottomMenu = {"BottomMenu": [menuItem.createPayment, menuItem.cancelTransaction, menuItem.delete]};

				// this.inventory ? bottomMenu.BottomMenu.unshift(menuItem.preview) : '';

				this.displayData.status==0 ? bottomMenu = {"BottomMenu": [menuItem.delete]} : '';

				this.setBottomMenu(tagId, bottomMenu, 
					{
						onSuccess: function (response) {
							console.log(response);
						},
						onError: function (error) {
							console.log(error);
						}
					}
				)
			},

			fn_menuItemClick: function(tagId, menuId, menuAction){
				// tagId id form future use
				// menuId id form future use
				if(menuAction=='edit' && this.displayData && this.displayData.transactionId){
					this.fn_edit();
				}
				else if(menuAction=='cancel'){
					// this.fn_cancelTransaction(this.displayData.transactionId, 'display');
					this.actionType = 'cancel';
					this.confirmationDialogHeader = "Cancel Transaction?";
					this.confirmationMessage = "Cancelled transaction cannot be uncancelled. Are you sure you want to cancel this transaction?"
					this.$refs['ref_dialogCancelDeleteTransaction'].dialog_confimation = true;
				}
				else if(menuAction=='delete'){
					this.actionType = 'delete';
					this.confirmationDialogHeader = "Delete Transaction?";
					this.confirmationMessage = "Deleted transaction cannot be restored. Are you sure you want to delete this transaction?"
					this.$refs['ref_dialogCancelDeleteTransaction'].dialog_confimation = true;
				}
				else if(menuAction=='share'){
					this.fn_shareInvoice('share');
				}
				else if(menuAction=='createPayment'){
					this.$router.push({path:'/transactions/payment/items/new', query:{tagId:this.guidWeb(), id:this.displayData.partyId, name:this.displayData.partyName, dt:1}});
				}
				else if(menuAction=='preview'){
					this.fn_previewInvoice(true, 'purchase');
				}
			},

			fn_edit: function () {
				this.$router.push("/transactions/purchase/"+this.toolbarTitle.toLowerCase().replace(/ /g,'')+"/items/"+this.displayData.transactionId+"/edit");
			},

			fn_closeDialog: function(){
				this.$refs['ref_dialogPermission'].dialog_permission = false;
			},

			fn_showWebView: function () {
				var viewObject = {};

				var tagId = null;
				this.$route.params && this.$route.params.tagId ? tagId = this.$route.params.tagId : '';
				var self = this;

				this.showWebView(tagId, viewObject, 
					{
						onSuccess: function(response){
				          console.log(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }, 
				        // onChange: null, 
				        onMenuItemClick: function (tagId, menuId, menuAction, itemId) {
							self.fn_menuItemClick(tagId, menuId, menuAction, itemId)
						}
					}
				);
			},
		},
		mounted: function(){
			this.fn_initializeSettings();

			window.js_globals.fn_getBottomMenu = this.fn_getBottomMenu;
			window.js_globals.fn_onBackPress = this.fn_goBack;

			this.fn_showWebView();
	        
			if(this.$route.params && this.$route.params.tagId){
				this.fn_get(this.$route.params.tagId);
			}
		},
		computed: {
			totalQty: function(){
	    		let totalQty = 0;
	    		if(this.itemsQuanity){
	    			for(let i=0; i<this.itemsQuanity.length; i++){
		    			totalQty += this.itemsQuanity[i].qty;
		    		}	
	    		}
	    		return totalQty;
	    	},
			roundOffValue: function(){
				if(this.displayData && this.displayData.roundOffValue){
					return this.displayData.roundOffValue;
				}
				else{
					return this.roundUpto2Decimals(this.displayData.roundedAmount - this.displayData.amount);
				}
			}
		},
		beforeRouteLeave (to, from, next) {
			if(this.$refs['ref_dialogCancelDeleteTransaction'].dialog_confimation){
				this.$refs['ref_dialogCancelDeleteTransaction'].dialog_confimation = false;
				next(false);
			}
			else{
				next(true);	
			}
	    }
		// computed:{
		// 	transactionNumber: function () {
		// 		let prefix = this.displayData.prefix ? this.displayData.prefix + '/' : '';
	 //    		let suffix = this.displayData.suffix ? '/' + this.displayData.suffix : '';
	 //    		let transactionNumber = this.displayData.transactionNumber ? this.displayData.transactionNumber : '';
	 //    		return prefix + transactionNumber + suffix;
		// 	}
		// }
	}

</script>


// WEBPACK FOOTER //
// src/components/transactions/forms/expense/display.vue